const fr = {
  greeting: 'Salutation',
};

export default fr;